import request from '@/utils/request'


// 查询知识库信息列表
export function listKnowledge(query) {
  return request({
    url: '/saifuneng/saifuneng-knowledge/list',
    method: 'get',
    params: query
  })
}

// 查询知识库信息分页
export function pageKnowledge(query) {
  return request({
    url: '/saifuneng/saifuneng-knowledge/page',
    method: 'get',
    params: query
  })
}

// 查询知识库信息详细
export function getKnowledge(data) {
  return request({
    url: '/saifuneng/saifuneng-knowledge/detail',
    method: 'get',
    params: data
  })
}

// 新增知识库信息
export function addKnowledge(data) {
  return request({
    url: '/saifuneng/saifuneng-knowledge/add',
    method: 'post',
    data: data
  })
}

// 修改知识库信息
export function updateKnowledge(data) {
  return request({
    url: '/saifuneng/saifuneng-knowledge/edit',
    method: 'post',
    data: data
  })
}

// 删除知识库信息
export function delKnowledge(data) {
  return request({
    url: '/saifuneng/saifuneng-knowledge/delete',
    method: 'post',
    data: data
  })
}

// 查询设备类型信息列表
export function listDeviceType(query) {
  return request({
    url: '/saifuneng/saifuneng-device-type/list',
    method: 'get',
    params: query
  })
}
